<!-- Modern Header -->
<div class="credit-header">
  <div class="header-content">
    <div class="header-left">
      <h1 class="page-title">
        <i class="pi pi-credit-card"></i>
        Credit Overview
      </h1>
      <p class="page-subtitle">
        View your clinic's credit limit and usage information
      </p>
    </div>
  </div>
</div>

<!-- Main Content -->
<div class="credit-content">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-content">
      <p-progressSpinner
        strokeWidth="3"
        animationDuration=".5s"
      ></p-progressSpinner>
      <p class="loading-text">Loading credit information...</p>
    </div>
  </div>

  <!-- Credit Information -->
  <div *ngIf="!loading && clinicCreditInfo" class="credit-info-section">
    <div class="credit-cards-grid">
      <!-- Credit Limit Card -->
      <div class="credit-card limit-card">
        <div class="card-header">
          <div class="card-icon">
            <i class="pi pi-wallet"></i>
          </div>
          <div class="card-title">
            <h3>Credit Limit</h3>
            <p>Total available credit</p>
          </div>
        </div>
        <div class="card-content">
          <div class="amount-display">
            <span class="currency">R</span>
            <span class="amount">{{ clinicCreditInfo.limit_amount | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>

      <!-- Used Amount Card -->
      <div class="credit-card used-card">
        <div class="card-header">
          <div class="card-icon">
            <i class="pi pi-chart-line"></i>
          </div>
          <div class="card-title">
            <h3>Used Amount</h3>
            <p>Credit currently utilized</p>
          </div>
        </div>
        <div class="card-content">
          <div class="amount-display">
            <span class="currency">R</span>
            <span class="amount">{{ clinicCreditInfo.used_amount | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>

      <!-- Remaining Credit Card -->
      <div class="credit-card remaining-card">
        <div class="card-header">
          <div class="card-icon">
            <i class="pi pi-check-circle"></i>
          </div>
          <div class="card-title">
            <h3>Remaining Credit</h3>
            <p>Available for use</p>
          </div>
        </div>
        <div class="card-content">
          <div class="amount-display">
            <span class="currency">R</span>
            <span class="amount">{{ clinicCreditInfo.remaining_credit | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Credit Progress Section -->
    <div class="credit-progress-section">
      <div class="progress-card">
        <div class="progress-header">
          <h3 class="progress-title">
            <i class="pi pi-chart-pie"></i>
            Credit Utilization
          </h3>
          <p class="progress-subtitle">
            Current usage as of {{ getFormattedCycleMonth() }}
          </p>
        </div>
        <div class="progress-content">
          <div class="progress-bar-container">
            <div class="progress-bar">
              <div 
                class="progress-fill" 
                [style.width.%]="getCreditUsagePercentage()"
                [class.warning]="getCreditUsagePercentage() > 70"
                [class.danger]="getCreditUsagePercentage() > 90"
              ></div>
            </div>
            <div class="progress-label">
              <span class="usage-percentage">{{ getCreditUsagePercentage() | number:'1.1-1' }}%</span>
              <span class="usage-text">of credit limit used</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Credit Details Section -->
    <div class="credit-details-section">
      <div class="details-card">
        <div class="details-header">
          <h3 class="details-title">
            <i class="pi pi-info-circle"></i>
            Credit Details
          </h3>
        </div>
        <div class="details-content">
          <div class="detail-row">
            <div class="detail-label">
              <i class="pi pi-calendar"></i>
              <span>Cycle Month</span>
            </div>
            <div class="detail-value">
              {{ getFormattedCycleMonth() }}
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label">
              <i class="pi pi-building"></i>
              <span>Clinic ID</span>
            </div>
            <div class="detail-value">
              {{ clinicCreditInfo.clinic_id }}
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-label">
              <i class="pi pi-percentage"></i>
              <span>Utilization Rate</span>
            </div>
            <div class="detail-value">
              {{ getCreditUsagePercentage() | number:'1.1-1' }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="!loading && !clinicCreditInfo && errorMessage" class="error-container">
    <div class="error-content">
      <i class="pi pi-exclamation-triangle error-icon"></i>
      <h3 class="error-title">Unable to Load Credit Information</h3>
      <p class="error-text">{{ errorMessage }}</p>
      <button
        pButton
        pRipple
        label="Retry"
        icon="pi pi-refresh"
        class="modern-button primary"
        (click)="loadClinicCredit()"
      ></button>
    </div>
  </div>
</div>